module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "part1ch4"
    }
  }), _vm._v("Green Eggs With (or Without) Ham")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_hdnote"
  }, [_vm._v("The funny thing about hard-boiled eggs is that the best ones, the ones without that dark line bordering a chalky egg yolk, aren’t boiled at all—the eggs start in cold water which is simply brought to a boil and then the pot gets covered and the eggs just sit in that warm, cozy hot tub. This gentle cooking, a true "), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("small victory")])]), _vm._v(", is something I learned from watching Julia Child, my beloved hero, on television (you should know that when I was growing up and had elected to spend all of my time in the kitchen, I was affectionately called “Julia-the-Child”). While I advise using the freshest ingredients as a baseline rule, the second "), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("small victory")])]), _vm._v(" here is that older eggs (by which I mean at least a week or two after you bought them) not only work well, they work "), _c('em', [_vm._v("better")]), _vm._v(" and are much easier to peel than fresh eggs. Served with an easy, punchy parsley sauce and a little bit of salty country ham (which you can absolutely skip but I couldn’t resist the recipe name), these savory eggs are one of my favorite breakfast items.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0034-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("SERVES 4")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("Packed "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" cup [20 g] fresh Italian parsley leaves, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1 small garlic clove, minced")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1 tsp red or white wine vinegar, plus more as needed")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("4")]), _vm._v(" cup [60 ml] olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("Kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("8 old eggs ("), _c('em', [_vm._v("at least")]), _vm._v(" a week old)")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("4 oz [115 g] sliced country ham for serving (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("In a small bowl, combine the parsley, garlic, vinegar, olive oil, and a pinch of salt and stir everything together. Taste for seasoning, adding a bit more salt and/or vinegar if you’d like. Let the sauce sit at room temperature while you prepare the eggs (this rest will allow the ingredients to really get to know each other, a good thing).")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Put the eggs in a saucepan that’s taller than it is wide and cover them with 1 in [2.5 cm] cold water. Set the pan over high heat and bring to a boil. The moment it comes to a full boil, turn off the heat, cover the pan, and let it sit for exactly 10 minutes. Meanwhile, fill a large bowl with half water and half ice and set it aside.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Using a strainer or a slotted spoon, transfer the eggs to the ice-water bath and let them chill until they’re cool enough to handle. Then, working with one egg at a time, crack the egg on your work surface and peel it (I like to rinse the peeled eggs under running water to make sure there’s no lingering shell).")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Cut the eggs in half or into quarters, whatever you prefer, and transfer them to a serving platter. Spoon the parsley sauce over the eggs and pile the ham alongside, if desired. Serve immediately.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebar1_hd"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "pg35sp1"
    }
  }), _c('strong', [_vm._v("SPIN-OFFS")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_c('a', {
    attrs: {
      "id": "pg35lev1"
    }
  }), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("FOR DEVILED EGGS")])]), _vm._v(", halve the hard-boiled eggs and put all the yolks in a medium bowl. Mash them together with mayonnaise (use plenty), a little mustard, and a few drops of hot sauce and then whisk it all together until it’s really smooth. Season the mixture with salt. Transfer to a plastic bag, snip off a bottom corner, and pipe the mixture into the hollowed-out egg whites. Top with snipped chives or parsley and/or a shake of paprika.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_c('a', {
    attrs: {
      "id": "pg35lev2"
    }
  }), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("FOR DEVILED-ISH EGGS")])]), _vm._v(" without much work, halve the hard-boiled eggs, spread the surface of each one with a generous amount of mayonnaise, douse them with hot sauce, and call it a day!")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_c('a', {
    attrs: {
      "id": "pg35lev3"
    }
  }), _vm._v("Instead of the parsley sauce, "), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("SPRINKLE WITH DUKKAH")])]), _vm._v(", a mixture of ground nuts and spices popular throughout the Middle East. I like to do one part each pistachios and sesame seeds pulsed in the food processor with a bit of ground coriander, fennel seeds, cumin seeds, and lots of freshly ground black pepper and kosher salt. This mixture is also really good on avocado toast or sprinkled over a bowl of any cooked grain. Keep any leftover dukkah in a jar and leave it out where you can see it so you don’t forget about it. You’ll be pleasantly surprised by how good it makes just about anything.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_c('a', {
    attrs: {
      "id": "pg35lev4"
    }
  }), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("TURN THE EGGS INTO SAUCE GRIBICHE")])]), _vm._v(", a classic French sauce that’s great with steamed asparagus, poached fish, or chicken. I also really like it on ham sandwiches. It’s also very good simply served on toast (preferably a slice that’s been rubbed with a raw garlic clove), which makes an excellent snack and an unexpected bite to have with cocktails. Simply chop a few hard-boiled eggs and mix them together with chopped capers, chopped parsley, mustard, a splash of vinegar, and plenty of olive oil. Mix and match these ingredients as you like, and feel free to try other herbs like tarragon, chives, and/or chervil.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20a183dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/015-part01chapter04.vue
// module id = 99
// module chunks = 0